import { CART_URL } from 'constants/Paths';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useCartActions } from 'zustand-lib/useCart';

interface Props {
  open?: boolean;
  children?: React.ReactNode;
}

export const WrapperValidateCart = ({ open, children }: Props) => {
  const router = useRouter();

  const { fetchCartData } = useCartActions();
  const [isLoading, setIsLoading] = useState(router.pathname === CART_URL);

  // Sync cart cache when user is on cart page
  const syncCartCache = async () => {
    if (router.pathname !== CART_URL) return;

    setIsLoading(true);
    await fetchCartData();
    setIsLoading(false);
  };

  useEffect(() => {
    if (open) {
      syncCartCache();
    }
  }, [open]);

  if (isLoading) {
    return (
      <div className="w-[80vw] xl:w-[1028px] h-[80vh] p-5 bg-white">
        <div className="w-full h-full bg-slate-200 animate-pulse rounded" />
      </div>
    );
  }

  return <>{children}</>;
};

